import { Button } from "@chakra-ui/button";
import {
    Box, Stack, Flex, Center, Heading, Text,
    GridItem,
    Grid,
} from "@chakra-ui/layout";
import {
    useDisclosure,
    theme,
    Wrap,
    useMediaQuery,
    VStack,
} from "@chakra-ui/react"

import NextLink from "next/link";
import { firebaseClient } from "../../firebaseClient";

import Tweets from "components/tweets";

import React, { useEffect } from "react";

import { useSession } from "next-auth/client";
import { getList, deleteList } from "controllers/bookmark";
import PuffLoader from "react-spinners/PuffLoader";
import { Page } from "components/page";
import * as analytics from "../../utils/analytics";
import { useRouter } from "next/dist/client/router";
import { getPlan } from "../../controllers/subscription";
import { updateUser } from "utils/sessionHelper";
import { getAccount } from "../../utils/sessionHelper";
import { textStyle } from "theme/names";

const selectedTabStyle = {
    borderBottom: "solid 2px" + theme.colors.blue[300],
    color: theme.colors.blue[300],
};


export const CustomAi = () => {

    const [session, loading] = useSession();
    const [savedTweet, setSavedTweet] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(false);
    const [tweets, setTweets] = React.useState([]);
    const [refresh, refresher] = React.useState({});
    const [hasInit, setHasInit] = React.useState(false);
    const router = useRouter();

    const getSavedTweets = async () => {
        // console.log("getSavedTweets");
        // console.log(session?.user?.uid);
        // console.log(loading);
        if (session?.user?.uid) {
            setIsLoading(true);
            //@ts-ignore
            const resTweets = await getList(getAccount(session).id, -3);
            //@ts-ignore
            // const ids = savedTweets.map((tweet) => tweet.id_str);
            setTweets(resTweets);

            //@ts-ignore
            setSavedTweet(resTweets);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (session?.user?.uid) {
            getSavedTweets();

            if (!hasInit) {
                setHasInit(true);
                let match = session?.user?.data?.lists?.find(x => x.id == -3);
                if (session?.user?.data?.lists && !match) {
                    session.user.data.lists.unshift({id: -3, name: "Custom AI Model 🤖"});
                    updateUser(session, {lists: session.user.data.lists});
                }
            }
        }
    }, [refresh, session]);


    return (
        <Box w="full">
            {
                getPlan(session?.user).includes("enterprise") ? (

                    isLoading ? (
                        <Center pt={10}>
                            <PuffLoader color={"hsl(203, 100%, 36%)"} loading={isLoading} css="display: block; margin: 0 auto; border-color: red;" size={50} />
                        </Center>
                    ) : (
                        tweets?.length > 0 && !loading ? (
                            <>
                                <Flex flexDirection="column" w="full" maxW="1000px">
                                    <Text mb={5} textStyle={textStyle["body.medium.light"]}>
                                        Tweets added to the Custom Model collection are used to customized our AI engine for you, leading to superior quality AI-generations. Engine is re-trained everytime you add a new tweet in the collection. 
                                    </Text>
                                    <Text mb={5} textStyle={textStyle["body.medium.light"]}>
                                        A minimum of 25 tweets is required to train the engine. Then, the more you add, the better the AI-generation will be.
                                    </Text>
                                    <Tweets
                                        savedTweet={savedTweet}
                                        tweets={tweets}
                                        refresher={refresher}
                                        refresh={refresh}
                                        disableHideButton={true}
                                        disableSaveCsv={true}
                                        disableEmbed={true}
                                    />
                                </Flex>
                            </>
                        ) : (
                            <Center mt={10}>
                                <Stack>
                                    <Text
                                        m={10}
                                        textAlign="center"
                                        fontSize="xl"
                                        fontWeight={500}
                                        textStyle={textStyle["h2.bold.standard"]}
                                    >
                                        No tweets to train your AI Custom Model
                                    </Text>
                                    <Text
                                        textStyle={textStyle["body.medium.light"]}
                                    >
                                        Add tweet in your collection "AI Custom Model" so Tweet Hunter can train your AI Custom Model.
                                    </Text>
                                    {/* <OrderedList mt={10} pl={10} maxW={"600px"}>
                                        <ListItem>Head to the <Button size="xs" onClick={() => { router.push("/search"); }}>Search</Button> section</ListItem>
                                        <ListItem>Search with @{session?.user?.data?.twUserName}</ListItem>
                                        <ListItem>Add the tweets you like in the "evergreen" collection</ListItem>
                                        <ListItem>Those tweets will be retweeted based on your evergreen schedule <Button size="xs" onClick={() => { tweetContext.onOpenEditSchedule() }}>Edit</Button></ListItem>
                                    </OrderedList> */}
                                </Stack>
                            </Center>
                        )
                    )
                ) : (
                    <Flex flexDirection="column" alignItems="center" mt={10}>
                        {/* <Heading mt={10} fontSize="lg">Want to use evergreen tweets?</Heading> */}
                        <VStack w="100%" maxW="600px" spacing={6} justifyContent="flex-start" textStyle={textStyle["body.medium.light"]}>
                            <Text textStyle={textStyle["h2.bold.standard"]} m={0} fontSize="md" fontWeight="600">Feature available to Enterprise plan users</Text>
                            <Text m={0} textStyle="body.medium.light">Our AI engine uses the most powerful available technology to find and generate the best possible content for you.</Text>
                            <Text m={0} textStyle="body.medium.light">For an even superior experience, we offer the ability to custom-train our AI engine for your specific needs and preferences.</Text>
                            <Text m={0} textStyle="body.medium.light">Add tweets to a collection and the AI will write tweets for you. Your own personal ghostwriter, at 1/10 of the market price.</Text>
                            </VStack>
                            <Button
                                mt={10}
                                // bg="gray.600"
                                variant={"primary"}
                                // color="white"
                                onClick={async () => {
                                    router.push("/pricing");
                                }}
                                    rightIcon={<svg width="14" height="14" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.25 2.71875L14.75 7.96875C14.9062 8.125 15 8.3125 15 8.53125C15 8.71875 14.9062 8.90625 14.75 9.0625L9.25 14.3125C8.96875 14.5938 8.46875 14.5938 8.1875 14.2812C7.90625 14 7.90625 13.5 8.21875 13.2188L12.375 9.28125H1.75C1.3125 9.28125 1 8.9375 1 8.53125C1 8.09375 1.3125 7.78125 1.75 7.78125H12.375L8.21875 3.8125C7.90625 3.53125 7.90625 3.03125 8.1875 2.75C8.46875 2.4375 8.9375 2.4375 9.25 2.71875Z" fill="currentColor"/>
                                    </svg>
                                    }
                            >
                                Go Enterprise
                            </Button>
                    </Flex>
                )
            }
        </Box>
    )

}